import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col } from 'react-bootstrap';

import errores from '../../../../middleware/errordb'

import config from '../../../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../../../subcomponent/mensajes';
import ModalConfirm from '../../../subcomponent/modalConfirm';
import TitleModule from '../../../widgets/module_title';
import BackButton from '../../../widgets/back_button';

class Formularioretenciones extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Retenciones",
            msg: 0,
            comp: "",
            id_retenciones: "",
            empresa: currentCompany,
            descripcion: "",
            tasa: "",
            tipo_rete: "",
            base: "",
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: ""
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_retenciones = "";
        const categoriaEdicion = search.replace('?', '');
        if (categoriaEdicion) {
            titulo = "Modificar Retenciones";
            id_retenciones = categoriaEdicion;
            const datasend = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'empresa': this.state.empresa,
                    'tipo': this.state.tipo,
                }
            }
            fetch(config.servBackEnd + '/withholdings/' + categoriaEdicion, datasend).then(response => response.json())
                .then(data => {
                    if (data.ok) {
                        const datos = data.data;
                        this.setState({
                            //descripcion: datos[0]["CODIGO_EMPRESA"],
                            descripcion: datos[0]["DESCRIPCION_RETENCION"],
                            tasa: datos[0]["PORCENTAJE_RETENCION"],
                            tipo_rete: datos[0]["TIPO_RETENCION"],
                            base: datos[0]["BASE_MINIMA_VENTA"]
                        });
                    } else {
                        this.setState({ mostrarMensaje: true, mensaje: data.message })
                    }
                });
        } else {
            titulo = "Crear Retenciones";
            id_retenciones = "";
        }
        this.setState({ id_retenciones, titulo });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { empresa } = this.state
        const { descripcion } = this.state
        const { tasa } = this.state
        const { tipo_rete } = this.state
        const { base } = this.state

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                empresa: empresa,
                descripcion: descripcion,
                tasa: tasa,
                tipo_rete: tipo_rete,
                base: base
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_retenciones === "") {
            ruta = config.servBackEnd + '/withholdings/create';
        } else {
            ruta = config.servBackEnd + '/withholdings/modify/' + this.state.id_retenciones;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoImpuesto = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_retenciones;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_retenciones: nuevoImpuesto })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Retenciones con errores:" + errores[data.code] + " " + data.message })
                }
            });
        event.preventDefault();
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const mensajeBoton = (this.state.id_retenciones === "") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_retenciones === "") ? '¿Esta seguro que desea crear la retención?' : '¿Esta seguro que desea modificar la retención?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1');
        return (
            <div className="Formularioretenciones">

                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <TitleModule text={this.state.titulo} />
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <BackButton />

                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Empresa</Form.Label>
                                            <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Descripcion</Form.Label>
                                            <Form.Control type="text" placeholder="Descripcion" onChange={e => this.setState({ descripcion: e.target.value.toUpperCase() })} value={this.state.descripcion} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Tipo</Form.Label>
                                            <Form.Control as="select" maxLength="2" placeholder="codigo" onChange={e => this.setState({ tipo_rete: e.target.value })} value={this.state.tipo_rete} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">RENTA</option>
                                                <option value="2">RETEIVA</option>
                                                <option value="3">RETEICA</option>
                                                <option value="4">RETEOTROS</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Porcentaje</Form.Label>
                                            <Form.Control type="number" step=".01" placeholder="%" onChange={e => this.setState({ tasa: e.target.value })} value={this.state.tasa} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>Base</Form.Label>
                                            <Form.Control type="number" placeholder="codigo" onChange={e => this.setState({ base: e.target.value })} value={this.state.base} required />
                                        </Form.Group>

                                    </Form.Row>

                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formularioretenciones);


// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/formularios/formularioRetenciones.jsx